import { Menu as MantineMenu } from '@mantine/core';
import classes from './menu.module.scss';

export const Menu = MantineMenu.extend({
  classNames: classes,
});
